import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {catchError, concatMap, map, mergeMap, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as LoginActions from '../actions/login.actions';
import {AuthenticateService} from '../../authenticate.service';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {CognitoService, IUser} from '../../../cognito.service';


declare let dataLayer: Array<any>;

@Injectable()
export class LoginEffects {

  cookiesLoginUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoginActions.CookiesLogin),
      switchMap(() => {
        const tokenIsValidAndData = this.authService.isAuthenticated();
        if (!tokenIsValidAndData.valid) {
          return of(LoginActions.loginUserFailed({error: 'Token Not Found', code: 100}));
        }
        return this.authService.checkAuth().pipe(map((res: any) => {
          if (res.code === 200) {
            return LoginActions.loginUserSuccess({userData: res.data});
          }
          return LoginActions.loginUserFailed({error: 'Token Not Found', code: 100});
        }));
      }),
      catchError(() => {
        return of(LoginActions.loginUserFailed({error: 'Token Not Found or Invalid', code: 100}));
      })
    );
  });

  // loginUser1$ = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(LoginActions.loginUser),
  //     switchMap(action => this.authService.loginUser(action.email, action.password).pipe(
  //       map((res: any) => {
  //         if (res.code === 200) {
  //           sessionStorage.setItem('token', res.data.accessToken);
  //           return LoginActions.loginUserSuccess({userData: res.data});
  //         }
  //         return LoginActions.loginUserFailed({code: res.code, error: res.data});
  //       }),
  //       catchError((e: HttpErrorResponse) => {
  //         if (e.status !== 200) {
  //           return of({type: '[General] Network Error', props: {error: {code: e.status}}});
  //         }
  //       })
  //     )),
  //   );
  // });

  loginUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoginActions.loginUser),
      switchMap(action =>
        this.cognitoService.signIn({ email: action.email, password: action.password } as IUser).pipe(
          switchMap((res: any) => {
            if (res?.error){
              let error = 'המשתמש איננו קיים או לא מופעל,\n' +
                'במידה והנך לקוח עסקי שכבר ביצע רישום ואקטיבציה למערכת , אנא שלח תעודת יבואן זעיר / יבואן עקיף/ מתווך ביבוא אישי למייל   elad@slickchain.com ';
              if  (res.error === 'Incorrect username or password.'){
                error = 'שם משתמש או סיסמא אינם נכונים';
              }

              return of(LoginActions.loginUserFailed({ code: 500, error }));
            }
            console.log(res);
            if (res?.signInUserSession?.accessToken?.jwtToken) {
              sessionStorage.setItem('token', res.signInUserSession.accessToken.jwtToken);
              sessionStorage.setItem('idToken', res.signInUserSession.idToken.jwtToken);
              // sessionStorage.setItem('user-id', res.username);
              return this.authService.getUserData(action.email).pipe(
                map((res: any) => {
                  if (res.code === 200) {
                    console.log(res);
                    sessionStorage.setItem('user-id', res.data.id);
                    dataLayer.push({
                      event: 'user-id',
                      user_id: res.data.id,
                      userId: res.data.id,
                    });

                    return LoginActions.loginUserSuccess({ userData: res.data });
                  }
                  return LoginActions.loginUserFailed({ code: res.code, error: res.data });
                }),
                catchError((e: HttpErrorResponse) => {
                  if (e.status !== 200) {
                    return of(LoginActions.loginUserFailed({ code: e.status, error: 'המשתמש איננו קיים או לא מופעל,\n' +
                        'במידה והנך לקוח עסקי שכבר ביצע רישום ואקטיבציה למערכת , אנא שלח תעודת יבואן זעיר / יבואן עקיף/ מתווך ביבוא אישי למייל   elad@slickchain.com ' }));
                    // return of({ type: '[General] Network Error', props: { error: { code: e.status } } });
                  }
                }),
              );
            }
            return of(LoginActions.loginUserFailed({ code: res.code, error: res.data }));
          }),
          catchError((e: HttpErrorResponse) => {
            if (e.status !== 200) {
              return of({ type: '[General] Network Error', props: { error: { code: e.status } } });
            }
          }),
        ),
      ),
    );
  });

  loadLogins$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoginActions.loadLogins),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => [])
    );
  });

  forgetPassword$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoginActions.forgetPassword),
      switchMap(action => this.authService.forgetPassword(action.email).pipe(map((res: any) => {
        if (res.code === 200) {
          return LoginActions.forgetPasswordSuccess();
        }
        return LoginActions.forgetPasswordFailed({error: res.data});
      })))
    );
  });

  logoutUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoginActions.LogoutUser),
      switchMap(action => this.authService.logout().pipe(map((res: any) => {
        if (res.code === 200) {
          this.cognitoService.signOut().then(() => {
            console.log('signout success');
          }).catch((err) => {
            console.log('signout error', err);
          }
          );
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('idToken');
          sessionStorage.removeItem('user-id');
          this.router.navigate(['/']);
          return LoginActions.LogoutUserSuccess();
        }
      })))
    );
  });


  constructor(private actions$: Actions,
              private authService: AuthenticateService,
              private router: Router,
              private cognitoService: CognitoService
  ) {
  }

}
